module.exports = __webpack_public_path__ + "img/005.4928e70f.png";